<template>
  <div class="w-100">
    <template v-if="(append !== '' || prepend !== '') && format !== ''">
      <b-input-group :prepend="prepend" :append="append">
        <template v-if="format === 'number'">
          <input type="text" v-model.lazy="displayNumber" class="form-control" :readonly="readonly" :placeholder="placeholder" @blur="updateValue" v-debounce:1000ms="debFuncNumber"/>
        </template>
        <template v-else-if="format === 'decimal'">
            <input type="text" v-model.lazy="displayDecimal" class="form-control" :readonly="readonly" :placeholder="placeholder" @blur="updateValue" v-debounce:1000ms="debFunc">
        </template>
        <template v-else>
          <input v-model="localValue" :type="type" class="form-control" :readonly="readonly" :placeholder="placeholder" :format="format" :max="applyRange && !ignoreRange ? max: null" :min="applyRange ? min: null" :step="step" @blur="updateValue" oninput="validity.valid||(value='');">
        </template>
      </b-input-group>
    </template>
    <template v-else-if="format === 'number'">
      <input type="text" v-model.lazy="displayNumber" class="form-control" :readonly="readonly" :placeholder="placeholder" @blur="updateValue" v-debounce:1000ms="debFuncNumber"/>
    </template>
    <template v-else-if="format === 'decimal'">
      <input type="text" v-model.lazy="displayDecimal" class="form-control" :readonly="readonly" :placeholder="placeholder" @blur="updateValue" v-debounce:1000ms="debFunc">
    </template>
    <template v-else-if="format !== ''">
      <input v-model="localValue" :type="type" class="form-control" :readonly="readonly" :placeholder="placeholder" :format="format" :max="applyRange && !ignoreRange ? max: null" :min="applyRange ? min: null" :step="step" @blur="updateValue" oninput="validity.valid||(value='');">
    </template>
    <template v-else-if="ignoreRange">
      <input v-model="localValue" :type="type" class="form-control" :readonly="readonly" :placeholder="placeholder" :min="min" :step="step" oninput="validity.valid||(value='');" @change="updateValue">
    </template>
    <template v-else>
      <input v-model="localValue" :type="type" class="form-control" :readonly="readonly" :placeholder="placeholder" :max="applyRange && !ignoreRange ? max: null" :min="applyRange ? min: null" :step="step" @blur="updateValue" oninput="validity.valid||(value='');">
    </template>
    <small v-if="description" tabindex="-1" class="form-text" :class="descriptionClass">{{ description }}</small>
  </div>
</template>

<script>
  export default {
    name: 'o-input-control',
    props: {
      value: {
        default: null
      },
      type: {
        type: String,
        default: 'text'
      },
      readonly: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String
      },
      applyRange: {
        type: Boolean,
        default: false
      },
      append: {
        type: String,
        default: ''
      },
      prepend: {
        type: String,
        default: ''
      },
      format: {
        type: String,
        default: ''
      },
      step: {
        type: Number,
        default: 0.01
      },
      min: {
        type: Number,
        default: 1
      },
      max: {
        type: Number,
        default: 99
      },
      ignoreRange: {
        type: Boolean,
        default: false
      },
      description: {
        type: String,
        default: ''
      },
      descriptionClass: {
        default: 'text-muted'
      }
    },

    data: () => ({
      localValue: '',
      previousValue: ''
    }),

    mounted() {
      this.localValue = this.value
    },

    components: {},

    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.localValue = newVal
        }
      },
      localValue(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.previousValue = oldVal
          this.$emit('input', newVal)
        }
      }
    },

    methods: {
      inRangValue (value) {
        if (!value) {
          return null
        }

        if(this.ignoreRange) {
          return this.ignoreRange ? (parseInt(value) === 0 ? null : (parseInt(value) < 0 ? Math.abs(value) : value)) : value
        }

        if (this.applyRange) {
          if (this.min > value) {
            value = this.min
          } else if (this.max < value) {
            value = this.max
          }
        }
        return value
      },
      updateValue () {
        this.localValue = this.inRangValue(this.localValue)
        this.$emit('previous-value', this.previousValue)
        this.$emit('blur', this.localValue)
      },
      debFunc (val, e) {
        if(val) {
          if(val === null) {
            return val
          }

          var val = this.roundByNum(val, 0.05)
          var ret = new Intl.NumberFormat('de-CH', {minimumFractionDigits: 2}).format(val)
          var number = ret.replace("\u2019", "'")
          // let newNumber = parseFloat(val.replace(/[^\d\.]/g, ""))
          // let number = parseFloat(newNumber).toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1’")
          if (number === 'NaN') {
            number = null
          }

          this.displayDecimal = number
        }
      },
      debFuncNumber (val, e) {
        if(val) {
          let newNumber = parseFloat(val.replace(/[^\d\.]/g, ""))
          var ret = new Intl.NumberFormat('de-CH', {minimumFractionDigits: 0}).format(Math.round(newNumber))
          ret = ret.replace("\u2019", "'")
          if (ret === 'NaN') {
            ret = null
          }
          this.displayNumber = ret
        }
      },
      roundByNum(num, rounder) {
        var multiplier = 1/(rounder||0.5);
        return Math.round(num*multiplier)/multiplier;
      }
    },
    computed: {
      displayNumber: {
        get: function() {
          var ret = new Intl.NumberFormat('de-CH', {minimumFractionDigits: 0}).format(Math.round(this.localValue))
          ret = ret.replace("\u2019", "'")
          if (ret === 'NaN') {
            ret = null
          }
          return ret
        },
        set: function(number) {
          let newNumber = parseInt(number.replace(/[^\d\.]/g, ""))
          if (isNaN(newNumber)) {
            newNumber = null
          }
          this.$emit('input', newNumber)
        }
      },
      displayDecimal: {
        get: function() {
          let number = parseFloat(this.localValue).toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1’")
          if (number === 'NaN') {
            number = null
          }
          return number
        },
        set: function(number) {
          if(number !== null) {
            let newNumber = parseFloat(number.replace(/[^\d\.]/g, ""))
            if (isNaN(newNumber)) {
              newNumber = null
            }
            this.$emit('input', newNumber)
          }
        }
      }
    }
  }
</script>
